export default __webpack_public_path__ + "static/media/selamat9.f8bebf2a.svg";